import React from "react";
import {
  StyledTabAppBar,
  StyledDivMenuAppBar,
  StyledButtonMenuDeroulant,
  StyledMenuItem,
  StyledButton,
  StyledRegularButton,
  StyledRegularButtonContainer,
} from "./styles";
import { Box, Menu, useTheme } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import {
  TAB,
  CONFIG_ONGLETS,
  CONFIG_USERS,
  CONFIG_CLIENTS,
  HOME,
} from "../../routes/utils";

const MENU_LIST = [
  {
    title: "Gestion des onglets",
    link: CONFIG_ONGLETS,
  },
  {
    title: "Gestion des utilisateurs",
    link: CONFIG_USERS,
  },
  {
    title: "Gestion des dossiers clients",
    link: CONFIG_CLIENTS,
  },
];

const MenuAppBar = ({ userContext, tabsList = [] }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (route) => {
    navigate(route);
    setAnchorEl(null);
  };

  const handleClickOnglet = (onglet) => {
    navigate(TAB, { state: onglet });
  };

  const theme = useTheme();

  return (
    <StyledDivMenuAppBar theme={theme}>
      <Box sx={{ flexGrow: 1, display: { md: "flex" } }}>
        <StyledRegularButtonContainer
          theme={theme}
          location={location}
          route={HOME}
        >
          <StyledRegularButton
            theme={theme}
            location={location}
            route={HOME}
            onClick={() => {
              navigate(HOME);
            }}
          >
            DASHBOARD
          </StyledRegularButton>
        </StyledRegularButtonContainer>
        {tabsList.map((onglet) => {
          return (
            <StyledTabAppBar
              theme={theme}
              key={onglet.id}
              location={location}
              onglet={onglet}
            >
              {onglet.visibility ? (
                <StyledButton
                  theme={theme}
                  location={location}
                  onglet={onglet}
                  key={onglet.id}
                  onClick={() => {
                    handleClickOnglet(onglet);
                  }}
                >
                  {onglet.name}
                </StyledButton>
              ) : (
                <>
                  {userContext?.profile?.isAdmin && (
                    <StyledButton
                      theme={theme}
                      location={location}
                      onglet={onglet}
                      key={onglet.id}
                      onClick={() => {
                        handleClickOnglet(onglet);
                      }}
                    >
                      {onglet.name}
                    </StyledButton>
                  )}
                </>
              )}
            </StyledTabAppBar>
          );
        })}
      </Box>
      {userContext?.profile?.isAdmin && (
        <>
          <StyledButtonMenuDeroulant
            theme={theme}
            location={location}
            id="menu-button"
            aria-controls="basic-menu"
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
          >
            Admin
          </StyledButtonMenuDeroulant>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": "menu-button",
            }}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
          >
            {MENU_LIST.map((item) => (
              <StyledMenuItem
                theme={theme}
                link={item.link}
                location={location}
                key={item.title}
                onClick={() => handleClose(item.link)}
              >
                {item.title}
              </StyledMenuItem>
            ))}
          </Menu>
        </>
      )}
    </StyledDivMenuAppBar>
  );
};

export default MenuAppBar;
